/**
 * **The client card's one live region.** Every tab of the card and every dialog raised over it —
 * Pomiary's markers, Ankiety's pane, Forma's panel, Przegląd's credit acts, the `⋯` menu's
 * settings — speaks through the region `ClientDetailScreen` mounts once, beside the tab panel.
 *
 * Two polite regions on one screen is a defect of its own: a screen reader may read either, and a
 * test asking for „the" status reads whichever comes first. So a tab never mounts its own; it asks
 * for the card's `announce`, which is stable for the screen's life.
 */

import { createContext, useContext } from 'react';

const CardAnnounceContext = createContext<((message: string) => void) | null>(null);

export const CardAnnouncerProvider = CardAnnounceContext.Provider;

export function useCardAnnounce(): (message: string) => void {
  const announce = useContext(CardAnnounceContext);
  if (announce === null) {
    throw new Error('useCardAnnounce is called outside the client card that owns the live region.');
  }
  return announce;
}
